var ubian = ubian || {};
ubian.payments = {
  googlePayInitialized: false,
  gpayParams: null,
  gpayProcessCallback: null,
  gpayCancelCallback: null,
  gpayFailCallback: null,
  showGPayButton: function () {
    $(".js-gpay-button-wrapper").show();
    $(".js-pay-other").hide();
  },
  hideGPayButton: function () {
    $(".js-gpay-button-wrapper").hide();
    $(".js-pay-other").show();
  },
  initGooglePay: function () {
    if (ubian_checkout_contains_invalid_items) {
      return;
    }
    ubian.payments.showGPayButton();
    if (ubian.payments.googlePayInitialized !== false) {
      return;
    }
    $(".js-gpay-button-wrapper").html(ubian.utils.loader());
    ubian.payments.googlePayInitialized = true;
    $.get(ubian.routes["googlepay_get_params"], function (res) {
      ubian.payments.gpayParams = res;
      ubian.payments.googlePay.tokenizationSpecification = {
        type: "PAYMENT_GATEWAY",
        parameters: {
          gateway: res.gateway,
          gatewayMerchantId: res.gatewayMerchantId,
        },
      };
      ubian.payments.googlePay.baseCardPaymentMethod.type =
        res.paymentMethodType;
      ubian.payments.googlePay.baseCardPaymentMethod.parameters.allowedAuthMethods =
        res.allowedCardAuthMethods;
      ubian.payments.googlePay.baseCardPaymentMethod.parameters.allowedCardNetworks =
        res.allowedCardNetworks;
      ubian.payments.googlePay.cardPaymentMethod = Object.assign(
        {},
        ubian.payments.googlePay.baseCardPaymentMethod,
        {
          tokenizationSpecification:
            ubian.payments.googlePay.tokenizationSpecification,
        }
      );
      var script = document.createElement("script");
      script.src = "https://pay.google.com/gp/p/js/pay.js";
      script.onload = ubian.payments.googlePay.onload;
      document.body.appendChild(script);
    });
  },
  initGooglePayParking: async function () {
    console.log('init googlepay parking');
    return new Promise(function (resolve, reject) {
      if (ubian.payments.googlePayInitialized !== false) {
        resolve();
      }
      ubian.payments.googlePayInitialized = true;
      $.get(ubian.routes["googlepay_get_params"], function (res) {
        ubian.payments.gpayParams = res;
        ubian.payments.googlePay.tokenizationSpecification = {
          type: "PAYMENT_GATEWAY",
          parameters: {
            gateway: res.gateway,
            gatewayMerchantId: res.gatewayMerchantId,
          },
        };
        ubian.payments.googlePay.baseCardPaymentMethod.type = res.paymentMethodType;
        ubian.payments.googlePay.baseCardPaymentMethod.parameters.allowedAuthMethods = res.allowedCardAuthMethods;
        ubian.payments.googlePay.baseCardPaymentMethod.parameters.allowedCardNetworks = res.allowedCardNetworks;
        ubian.payments.googlePay.cardPaymentMethod = Object.assign(
          {},
          ubian.payments.googlePay.baseCardPaymentMethod,
          {
            tokenizationSpecification:
              ubian.payments.googlePay.tokenizationSpecification,
          }
        );
        var script = document.createElement("script");
        script.src = "https://pay.google.com/gp/p/js/pay.js";
        script.onload = function () {
          var paymentsClient = ubian.payments.googlePay.getGooglePaymentsClient();
          paymentsClient
            .isReadyToPay(ubian.payments.googlePay.getGoogleIsReadyToPayRequest())
            .then(function (response) {
              if (response.result) {
                // @todo prefetch payment data to improve performance after confirming site functionality
                // prefetchGooglePaymentData();
                resolve(response.result);
              } else {
                reject(ubian.translate("Basket.PaymentType.GooglePay.NotReady"))
              }
            })
            .catch(function (err) {
              console.error(err);
              reject(err);
            });
        };
        document.body.appendChild(script);
      });
    })
  },
  // https://developers.google.com/pay/api/web/guides/tutorial#js-load
  googlePay: {
    baseRequest: {
      apiVersion: 2,
      apiVersionMinor: 0,
    },
    tokenizationSpecification: {},
    baseCardPaymentMethod: {
      type: "CARD",
      parameters: {
        allowedAuthMethods: [],
        allowedCardNetworks: [],
      },
    },
    cardPaymentMethod: null,
    paymentsClient: null,
    getGooglePaymentsClient: function () {
      if (ubian.payments.googlePay.paymentsClient === null) {
        ubian.payments.googlePay.paymentsClient =
          new google.payments.api.PaymentsClient({
            environment: ubian.payments.gpayParams.environment,
          });
      }
      return ubian.payments.googlePay.paymentsClient;
    },
    getGoogleIsReadyToPayRequest: function () {
      return Object.assign({}, ubian.payments.googlePay.baseRequest, {
        allowedPaymentMethods: [ubian.payments.googlePay.baseCardPaymentMethod],
      });
    },

    getGooglePaymentDataRequest: function (transactionInfo = null) {
      var paymentDataRequest = Object.assign(
        {},
        ubian.payments.googlePay.baseRequest
      );
      paymentDataRequest.allowedPaymentMethods = [
        ubian.payments.googlePay.cardPaymentMethod,
      ];
      paymentDataRequest.transactionInfo = transactionInfo || ubian.payments.googlePay.getGoogleTransactionInfo();
      paymentDataRequest.merchantInfo = {
        merchantId: ubian.payments.gpayParams.googlePayMerchantId,
        merchantName: ubian.payments.gpayParams.merchantName,
      };
      return paymentDataRequest;
    },

    getGoogleTransactionInfo: function () {
      return {
        countryCode: ubian.payments.gpayParams.countryCode,
        currencyCode: ubian_checkout_currency,
        totalPriceStatus: "FINAL",
        totalPrice: ubian_checkout_total.toFixed(2),
      };
    },
    onGooglePaymentButtonClicked: function () {
      if (!ubian.payments.checkBeforeSubmit()) {
        return false;
      }
      var paymentDataRequest =
        ubian.payments.googlePay.getGooglePaymentDataRequest();
      if (typeof ubian_android_app != 'undefined') {
        ubian_android_app.postGPayData(JSON.stringify(paymentDataRequest));
        return;
      }
      var paymentsClient = ubian.payments.googlePay.getGooglePaymentsClient();
      paymentsClient
        .loadPaymentData(paymentDataRequest)
        .then(function (paymentData) {
          ubian.payments.googlePay.processPayment(paymentData);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    processPayment: function (paymentData) {
      var paymentToken = paymentData.paymentMethodData.tokenizationData.token;
      if (ubian.payments.gpayProcessCallback) {
        ubian.payments.gpayProcessCallback(btoa(paymentToken));
        ubian.payments.gpayProcessCallback = null;
        return;
      }
      $('#js-gpay-payload').val(btoa(paymentToken));
      ubian.utils.fullscreenProgress();
      ubian.payments.dispatchVueEvent();
      $('#js-payment-submit').submit();
    },
    paymentCancelled: function (data) {
      console.log(arguments);
      if (ubian.payments.gpayCancelCallback) {
        ubian.payments.gpayCancelCallback(data);
        ubian.payments.gpayCancelCallback = null;
      }
    },
    paymentFailed: function (data) {
      console.log(arguments);
      if (ubian.payments.gpayFailCallback) {
        ubian.payments.gpayFailCallback(data);
        ubian.payments.gpayFailCallback = null;
      }
    },

    addGooglePayButton: function (returnInstance, onClickHandler) {
      var paymentsClient = ubian.payments.googlePay.getGooglePaymentsClient();
      var button = paymentsClient.createButton({
        onClick: onClickHandler ? onClickHandler : ubian.payments.googlePay.onGooglePaymentButtonClicked,
        buttonSizeMode: "fill",
        buttonColor: "white",
        buttonType: "pay",
        buttonLocale: 'sk',
        allowedPaymentMethods: [ubian.payments.googlePay.baseCardPaymentMethod],
      });
      if (!returnInstance) {
        $(".js-gpay-button-wrapper").html("");
        $(".js-gpay-button-wrapper")[0].appendChild(button);
        ubian.payments.showGPayButton();
        return;
      }
      return button;
    },
    onload: function () {
      var paymentsClient = ubian.payments.googlePay.getGooglePaymentsClient();
      paymentsClient
        .isReadyToPay(ubian.payments.googlePay.getGoogleIsReadyToPayRequest())
        .then(function (response) {
          if (response.result) {
            ubian.payments.googlePay.addGooglePayButton();
            // @todo prefetch payment data to improve performance after confirming site functionality
            // prefetchGooglePaymentData();
          } else {
            $(".js-gpay-button-wrapper").html("<div class='error'>" + ubian.translate("Basket.PaymentType.GooglePay.NotReady") + "</div>");
          }
        })
        .catch(function (err) {
          // show error in developer console for debugging
          console.error(err);
        });
    },
  },
  dispatchVueEvent: function (isSubmit) {
    var data = {
      'paymentMethod': $('#js-payment-method').val(),
      'paymentCard': $('#js-payment-card').val(),
      'rememberCard': $('#js-remember-card').val(),
      'jsGpayPayload': $('#js-gpay-payload').val(),
      'submit': typeof isSubmit !== 'undefined' ? isSubmit : false
    };
    window.dispatchEvent(new CustomEvent('vuePaymentDataEvent', { detail: data }));
  },
  checkBeforeSubmit: function () {
    if (typeof ubian_skip_check_before_submit != 'undefined' && ubian_skip_check_before_submit) {
      return true;
    }
    // check terms of service are checked
    if (!$(".js-agreement-tos").is(":checked")) {
      $(".js-agreement-tos-required").show();
      return false;
    }
    // check remembered card id
    if (
      $("#js-payment-method").val() === ubian_card_payment_method &&
      $("#js-payment-card").val() == "-1"
    ) {
      ubian.utils.alert(ubian.translate("JS.Error.Basket.SelectCard"));
      return false;
    }
    if (typeof vuePaymentCheckBeforeSubmit != 'undefined'){
      return vuePaymentCheckBeforeSubmit();
    }
    return true;
  },
  updateSelectedPayment: function () {
    var $input = $("input[name=payment_method]:checked");
    var canRemember = $input.data("remember-option") ? true : false;
    var paymentMethod = $input.data("payment-method");
    var cardId = $input.data("card-id");
    if (canRemember) {
      $(".js-remember-card-row").show();
    } else {
      $(".js-remember-card-row").hide();
      $(".js-remember-card-row input").prop("checked", false);
      $(".js-remember-card-row input").change();
    }
    $("#js-payment-method").val(paymentMethod);
    if (cardId) {
      $("#js-payment-card").val(cardId);
    } else {
      $("#js-payment-card").val("0");
    }
    if (paymentMethod == "GooglePay") {
      ubian.payments.initGooglePay();
    } else {
      ubian.payments.hideGPayButton();
    }
    ubian.payments.dispatchVueEvent();
  },
  init: function () {
    if ($(".js-payment-selector").length === 0) {
      return;
    }
    $("#js-payment-submit").submit(function () {
      var check = ubian.payments.checkBeforeSubmit();
      if ($('#js-payment-submit').data('is-vue-component')) {
        if (check) {
          ubian.payments.dispatchVueEvent(true);
          return false;
        }
      } else {
        return check;
      }
    });
    var $paymentsWrapper = $(".payment-wrapper");

    function uncheckAll() {
      $(".item").addClass("dim");
      $(".sub-item").addClass("dim");
      $("input[name=payment_method]").prop("checked", false);
    }

    function checkMainItem(item) {
      $(item).removeClass("dim");
      $(item).find(".head input").prop("checked", true);
    }

    function checkSubItem(item) {
      $(item).removeClass("dim");
      $(item).find("input").prop("checked", true);
    }
    $(".js-remember-card-checkbox").change(function () {
      $("#js-remember-card").val($(this).is(":checked") ? 1 : 0);
      ubian.payments.dispatchVueEvent();
    });
    $paymentsWrapper.find(".item").on("click", function (e) {
      if ($(this).find(".sub-item").length) {
        return;
      }
      uncheckAll();
      checkMainItem(this);
      ubian.payments.updateSelectedPayment();
    });

    $paymentsWrapper.find(".sub-item").on("click", function (e) {
      e.stopImmediatePropagation();
      if ($(this).data("disabled")) {
        return;
      }
      uncheckAll();
      var parent = $(this).parents(".item");
      checkMainItem(parent);
      checkSubItem(this);
      ubian.payments.updateSelectedPayment();
    });
    $("input[name=payment_method]").not(":disabled").first().click();
    ubian.payments.updateSelectedPayment();
  },
  unblockFromInvalidItems: function (res) {
    $('.js-pay-other').removeAttr('disabled');
    ubian_checkout_contains_invalid_items = false;
    ubian_checkout_total = res.totalPrice;
    ubian.payments.updateSelectedPayment();
  }
};

// initialize payments
$(function () {
  ubian.payments.init();
  $("#agreement-tos").on("change", function () {
    if ($(this).prop('checked')) {
      $(".js-agreement-tos-required").css("display", "none");
    }
  });
});
